import script from "./AppModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppModal.vue?vue&type=script&lang=ts&setup=true"

import "./AppModal.vue?vue&type=style&index=0&id=094abd04&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-094abd04"]])

export default __exports__